
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><inlineCode parentName="h3">{`useTheme`}</inlineCode>{` | v5`}</h3>
    <p>{`This is a custom hook to get the current theme from a `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useTheme } from 'styled-components'

function MyComponent() {
  const theme = useTheme()
  console.log('Current theme: ', theme)

  // ...
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`All styled components `}<a parentName="p" {...{
          "href": "/docs/advanced#theming"
        }}>{`automatically receive the theme as a prop`}</a>{`, so this is only necessary if you wish to access the theme for other reasons.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;